<template>
	<div class="pt-2">
		<CommonFlame :title="title" :maxWidth="'auto'">
			<MultipleLineGanttChart
				:taskTitle="''"
				:tasks="order_individual_infos"
				:taskArrayName="taskArrayName"
				:taskNameKey="'name'"
				:startDateKey="startDateKey"
				:endDateKey="endDateKey"
				:fontSize="fontSize"
				:taskBarStyle="taskBarStyle"
				:taskBarNameStyle="taskBarNameStyle"
				:taskBarType="'bar'"
				:changeDatetimeFlag="authority_flag"
				:chart_type.sync="chartType"
				:taskTitleHeight="48"
				:noTaskText="'製造番号を追加してください'"
				:display_date="today"
				syncChartType
				showDates
				showCells
				onlyDateChartType
				@change-datetime="changeDatetime($event)"
			>
				<template v-slot:top-section>
					<v-form ref="form" v-model="valid">
						<v-row no-gutters>
							<v-col class="px-1 mt-4" cols="12" sm="6" md="3">
								<v-select
									label="対象部門"
									:items="departments"
									v-model="department"
									return-object
									dense
									:rules="[rules.required]"
									outlined
								/>
							</v-col>
							<v-col class="px-1 mt-4" cols="12" sm="6" md="3">
								<v-select
									label="対象者"
									v-model="user"
									:items="users"
									item-text="full_name"
									item-value="id"
									dense
									:rules="[rules.required]"
									outlined
									:hint="department ? '部門を選択してください' : ''"
								/>
							</v-col>
							<v-col class="px-1 mt-4" cols="12" sm="6" md="3">
								<v-menu
									ref="menu"
									close-on-content-click
									transition="scale-transition"
									offset-y
									min-width="auto"
								>
									<template v-slot:activator="{ on, attrs }">
										<v-text-field
											:rules="[rules.required]"
											label="対象日"
											v-model="date"
											outlined
											dense
											readonly
											v-bind="attrs"
											v-on="on"
										/>
									</template>
									<v-date-picker v-model="date" no-title scrollable locale="ja" />
								</v-menu>
							</v-col>
							<v-col class="px-1 mt-4 text-right" cols="12" sm="6" md="3">
								<v-btn color="secondary" :disabled="valid" @click="saveRequiredTimes"
									>変更を保存する</v-btn
								>
							</v-col>
						</v-row>
					</v-form>
				</template>

				<template v-slot:task-top-section>
					<v-col class="gantt-task" cols="12">製造番号</v-col>
				</template>
				<template v-slot:task-list="{ task }">
					<v-col class="task-name" cols="12">
						{{ common.productNumberByOrderIndividualInfo(task) }}
					</v-col>
				</template>
				<template v-slot:below-chart>
					<AddOrderIndividualInfoDialog
						:existing_order_individual_infos="order_individual_infos"
						@add-order-individual-infos="addOrderIndividualInfos($event)"
					/>
				</template>
			</MultipleLineGanttChart>
		</CommonFlame>
	</div>
</template>

<script>
import moment from "moment"
import axios from "axios"
import authenticate from "../../helper/authenticate"
import errorHandling from "../../helper/errorHandling"
import common from "../../helper/common"
import rules from "../../helper/rules"
import CommonFlame from "../shared/CommonFlame.vue"
import MultipleLineGanttChart from "../shared/MultipleLineGanttChart.vue"
import AddOrderIndividualInfoDialog from "./components/AddOrderIndividualInfoDialog.vue"

export default {
	components: {
		CommonFlame,
		MultipleLineGanttChart,
		AddOrderIndividualInfoDialog,
	},
	data() {
		return {
			title: "一括作業時間入力",
			order_individual_infos: [],
			departments: [],
			department: null,
			user: null,
			date: moment().format("YYYY-MM-DD"),
			today: moment().format("YYYY-MM-DD"),
			taskArrayName: "required_times",
			startDateKey: "start_date",
			endDateKey: "end_date",
			authority_flag: false,
			fontSize: "14px",
			taskBarStyle: {
				textAlign: "center",
				height: "24px",
				paddingBottom: "4px",
				borderRadius: 0,
			},
			taskBarNameStyle: {
				fontSize: ".9rem",
				color: "black",
			},
			changedProcesses: [],
			valid: false,
			chartType: "one-day",
			common,
			rules,
		}
	},

	mounted() {
		this.fetchData()
	},
	methods: {
		fetchData() {
			const headers = authenticate.setHeader()
			axios
				.get("/erp/v1/required_times/new", {
					headers,
				})
				.then((res) => {
					this.departments = res.data.departments
				})
				.catch((err) => {
					errorHandling.errorResponse(err)
				})
		},
		addOrderIndividualInfos(infos) {
			this.order_individual_infos = this.order_individual_infos.concat(infos)
		},
		confirmSave(event) {
			event.returnValue = "変更したデータは保存されませんが、よろしいですか？"
		},
		changeDatetime(requiredTime) {
      // TODO
			window.addEventListener("beforeunload", this.confirmSave)
		},

		saveRequiredTimes() {
			// TODO
			const headers = authenticate.setHeader()
			const url = `/erp/v1/required_times`
			const params = {}
			axios
				.post(url, params, {
					headers,
				})
				.then((res) => {
					res.data.forEach((requiredTime) => {
						// TODO
					})
					this.changedProcesses = []
					window.removeEventListener("beforeunload", this.confirmSave)
				})
				.catch((err) => {
					errorHandling.errorResponse(err)
				})
		},
	},
	computed: {
		users() {
			if (!this.department) return []
			return this.department.users
		},
	},
	destroyed() {
		window.removeEventListener("beforeunload", this.confirmSave)
	},
	beforeRouteLeave(to, from, next) {
		if (!this.changedProcesses.length) {
			window.removeEventListener("beforeunload", this.confirmSave)
			next()
			return
		}
		const answer = window.confirm("変更したデータは保存されませんが、よろしいですか？")
		if (answer) {
			window.removeEventListener("beforeunload", this.confirmSave)
			next()
		} else {
			next(false)
		}
	},
}
</script>
